import { useEffect } from 'react';

import { useBenefitDesignInputsStore } from '@/features/shop-insurance/stores/benefit-design-inputs-store';
import { useBenefitTypeFilterStore } from '@/features/shop-insurance/stores/benefit-type-filter-store';
import { useCarrierExclusionsStore } from '@/features/shop-insurance/stores/carrier-exclusions-store';
import { useEligibilityFiltersStore } from '@/features/shop-insurance/stores/eligibility-filters-store';

// The filter stores are module-level singletons so that filter state survives
// navigation within one client. That also means it survives switching clients,
// which is not wanted — the owning client is tracked here (outside React, so an
// unmount/remount for the same client keeps its filters) and the stores are
// cleared whenever the shop opens for a different client.
let filterStoreOwnerClientId: string | undefined;

export function resetShopInsuranceFilterStores() {
  useBenefitTypeFilterStore.getState().actions.reset();
  useEligibilityFiltersStore.getState().actions.reset();
  useCarrierExclusionsStore.getState().actions.resetCarriers();
  useBenefitDesignInputsStore.getState().actions.reset();
}

export function clearShopInsuranceFilterStoreOwner() {
  filterStoreOwnerClientId = undefined;
}

export function useShopInsuranceStoreReset(clientId: string | undefined) {
  useEffect(() => {
    if (!clientId || clientId === filterStoreOwnerClientId) return;
    const isClientSwitch = filterStoreOwnerClientId !== undefined;
    filterStoreOwnerClientId = clientId;
    if (isClientSwitch) {
      resetShopInsuranceFilterStores();
    }
  }, [clientId]);
}
